export default __webpack_public_path__ + "static/media/elastic.af464e1f.png";